"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputBaseStyles = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _TextField = _interopRequireDefault(require("@mui/material/TextField/TextField.js"));

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles/makeStyles.js"));

var _Colors = _interopRequireDefault(require("../../styles/Colors"));

var _excluded = ["width", "margin", "hint"],
    _excluded2 = ["inputWrapper", "helperTextWrapper"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var inputBaseStyles = {
  position: 'relative',
  width: '100%',
  margin: 0,
  '& .MuiInputBase-root': {
    height: '56px',
    borderBottom: "4px solid ".concat(_Colors.default.secondaryGrey),
    borderRadius: '4px',
    backgroundColor: _Colors.default.lightestGrey,
    fontSize: '15px',
    margin: 0
  },
  '& .MuiInputBase-root.Mui-error': {
    borderBottomColor: _Colors.default.warningRed
  },
  '& .MuiInputBase-root.Mui-error.Mui-focused': {
    borderBottomColor: _Colors.default.warningRed
  },
  '& .MuiInputBase-root.Mui-root': {
    backgroundColor: _Colors.default.lightestGrey
  },
  '& .MuiInputBase-root:hover:before': {
    border: 0
  },
  '& .MuiInputBase-root.Mui-focused': {
    borderBottomColor: _Colors.default.orange
  },
  '& .MuiFilledInput-underline:before': {
    borderBottom: 'none'
  },
  '& .MuiInput-underline:before': {
    content: 'none'
  },
  '& .MuiFilledInput-underline:after, .MuiInput-underline:after': {
    borderBottom: 'none'
  },
  '& .MuiFormHelperText-root': {
    fontFamily: 'Lato',
    fontSize: '11px',
    margin: '0 13px',
    position: 'absolute',
    bottom: '-16px',
    height: '16px',
    lineHeight: '16px',
    overflow: 'hidden'
  },
  '&.isReadOnly': {
    '& .MuiInputBase-root': {
      borderBottomColor: _Colors.default.secondaryGrey,
      opacity: 0.5
    },
    '& .MuiFormLabel-root': {
      color: _Colors.default.secondaryGrey
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: _Colors.default.secondaryGrey
    }
  },
  '&.isDisabled': {
    opacity: 0.5
  }
};
exports.inputBaseStyles = inputBaseStyles;
var useStyle = (0, _makeStyles.default)({
  root: _objectSpread(_objectSpread({}, inputBaseStyles), {}, {
    // Text Area Styles
    '& .MuiInputBase-root': {
      height: function height(props) {
        return props.multiline ? '130px' : '56px';
      },
      borderBottom: "4px solid ".concat(_Colors.default.secondaryGrey),
      borderRadius: '4px',
      backgroundColor: _Colors.default.lightestGrey,
      fontSize: '15px'
    },
    '& .MuiFilledInput-multiline': {
      paddingRight: 4
    },
    '& ::-webkit-scrollbar': {
      width: 3
    },
    '& ::-webkit-scrollbar-thumb': {
      backgroundColor: _Colors.default.secondaryGrey,
      opacity: 0.5,
      borderRadius: 1
    }
  }),
  inputWrapper: function inputWrapper(_ref) {
    var margin = _ref.margin,
        width = _ref.width;
    return {
      margin: margin,
      width: width,
      display: 'flex',
      flexDirection: 'column',
      fontFamily: 'Lato'
    };
  },
  helperTextWrapper: function helperTextWrapper(_ref2) {
    var error = _ref2.error;
    return {
      display: 'block',
      color: error ? _Colors.default.warningRed : _Colors.default.secondaryGrey
    };
  }
});

var Input = /*#__PURE__*/_react.default.forwardRef(function (_ref3, ref) {
  var width = _ref3.width,
      margin = _ref3.margin,
      _ref3$hint = _ref3.hint,
      hint = _ref3$hint === void 0 ? '' : _ref3$hint,
      rest = _objectWithoutProperties(_ref3, _excluded);

  var disabled = rest.disabled,
      error = rest.error,
      multiline = rest.multiline,
      inputProps = rest.inputProps;

  var _useStyle = useStyle({
    multiline: multiline,
    error: error,
    width: width,
    margin: margin
  }),
      inputWrapper = _useStyle.inputWrapper,
      helperTextWrapper = _useStyle.helperTextWrapper,
      classes = _objectWithoutProperties(_useStyle, _excluded2);

  return /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({
    ref: ref,
    classes: classes,
    className: "".concat(inputWrapper, " ").concat(inputProps !== null && inputProps !== void 0 && inputProps.readOnly ? 'isReadOnly' : '', " ").concat(disabled ? 'isDisabled' : ''),
    variant: "filled",
    helperText: /*#__PURE__*/_react.default.createElement("span", {
      className: helperTextWrapper
    }, hint),
    color: "primary"
  }, rest));
});

var _default = Input;
exports.default = _default;